$.datepicker.setDefaults({
    dateFormat: 'mm/dd/yy',
    beforeShowDay: function(date) {
        var day = date.getDay(),
            formattedDate = Alkami.Utils.DateHelper.getIsoDate(date),
            isWeekend = $.inArray(day, [0, 6]) > -1,
            isHoliday = $.inArray(formattedDate, window.BANK_HOLIDAYS || []) > -1;

        if (isHoliday) {
            return [false, 'ui-holiday'];
        } else if (isWeekend) {
            return [false, ''];
        } else {
            return [true, ''];
        }
    },
    minDate: $.TODAY,
    showOtherMonths: true,
    selectOtherMonths: true,
    buttonImage: '/images/calendar.png',
    buttonText: 'Choose a date',
    buttonImageOnly: true,
    showOn: 'button',

    monthNames: [
        Alkami.Localization.SiteText["jQuery.Month.Full.January"],
        Alkami.Localization.SiteText["jQuery.Month.Full.February"],
        Alkami.Localization.SiteText["jQuery.Month.Full.March"],
        Alkami.Localization.SiteText["jQuery.Month.Full.April"],
        Alkami.Localization.SiteText["jQuery.Month.Full.May"],
        Alkami.Localization.SiteText["jQuery.Month.Full.June"],
        Alkami.Localization.SiteText["jQuery.Month.Full.July"],
        Alkami.Localization.SiteText["jQuery.Month.Full.August"],
        Alkami.Localization.SiteText["jQuery.Month.Full.September"],
        Alkami.Localization.SiteText["jQuery.Month.Full.October"],
        Alkami.Localization.SiteText["jQuery.Month.Full.November"],
        Alkami.Localization.SiteText["jQuery.Month.Full.December"]
    ],
    monthNamesShort: [
        Alkami.Localization.SiteText["jQuery.Month.Abbr.January"],
        Alkami.Localization.SiteText["jQuery.Month.Abbr.February"],
        Alkami.Localization.SiteText["jQuery.Month.Abbr.March"],
        Alkami.Localization.SiteText["jQuery.Month.Abbr.April"],
        Alkami.Localization.SiteText["jQuery.Month.Abbr.May"],
        Alkami.Localization.SiteText["jQuery.Month.Abbr.June"],
        Alkami.Localization.SiteText["jQuery.Month.Abbr.July"],
        Alkami.Localization.SiteText["jQuery.Month.Abbr.August"],
        Alkami.Localization.SiteText["jQuery.Month.Abbr.September"],
        Alkami.Localization.SiteText["jQuery.Month.Abbr.October"],
        Alkami.Localization.SiteText["jQuery.Month.Abbr.November"],
        Alkami.Localization.SiteText["jQuery.Month.Abbr.December"]
    ],
    dayNames: [
        Alkami.Localization.SiteText["jQuery.Day.Full.Sunday"],
        Alkami.Localization.SiteText["jQuery.Day.Full.Monday"],
        Alkami.Localization.SiteText["jQuery.Day.Full.Tuesday"],
        Alkami.Localization.SiteText["jQuery.Day.Full.Wednesday"],
        Alkami.Localization.SiteText["jQuery.Day.Full.Thursday"],
        Alkami.Localization.SiteText["jQuery.Day.Full.Friday"],
        Alkami.Localization.SiteText["jQuery.Day.Full.Saturday"]
    ],
    dayNamesShort: [
        Alkami.Localization.SiteText["jQuery.Day.Abbr.Sunday"],
        Alkami.Localization.SiteText["jQuery.Day.Abbr.Monday"],
        Alkami.Localization.SiteText["jQuery.Day.Abbr.Tuesday"],
        Alkami.Localization.SiteText["jQuery.Day.Abbr.Wednesday"],
        Alkami.Localization.SiteText["jQuery.Day.Abbr.Thursday"],
        Alkami.Localization.SiteText["jQuery.Day.Abbr.Friday"],
        Alkami.Localization.SiteText["jQuery.Day.Abbr.Saturday"]
    ],
    dayNamesMin: [
        Alkami.Localization.SiteText["jQuery.Day.TwoLetter.Sunday"],
        Alkami.Localization.SiteText["jQuery.Day.TwoLetter.Monday"],
        Alkami.Localization.SiteText["jQuery.Day.TwoLetter.Tuesday"],
        Alkami.Localization.SiteText["jQuery.Day.TwoLetter.Wednesday"],
        Alkami.Localization.SiteText["jQuery.Day.TwoLetter.Thursday"],
        Alkami.Localization.SiteText["jQuery.Day.TwoLetter.Friday"],
        Alkami.Localization.SiteText["jQuery.Day.TwoLetter.Saturday"]
    ]
});

$.validator.addMethod("greaterThanOrEqualTo", function(value, element, expression) {
    return (this.optional(element) && value == '') || ($(expression).val() >= value);
}, "Value must be greater than specified.");

$.validator.addMethod("regex", function(value, element, regexp) {
    if (regexp.constructor != RegExp)
        regexp = new RegExp(regexp);
    else if (regexp.global)
        regexp.lastIndex = 0;
    return this.optional(element) || regexp.test(value);
}, "Please check your input.");

$.validator.addMethod("noSpecialChars", function(value, element) {
    return this.optional(element) || value.match(/^[A-Za-z\d\s]+$/);
}, "Please remove any special characters.");

$.validator.addMethod("futureDate", function(value, element, params) {
    const date = parseDate(value, 'mm/dd/yyyy');
    const yesterday = Alkami.Utils.DateHelper.addMilliseconds(Alkami.Utils.DateHelper.today(), -1);
    return this.optional(element) || date > yesterday;
}, "Date can't be in the past.");

$.validator.addMethod("notEqualTo", function(value, element, params) {
    return this.optional(element) || ($(params).val() != value);
}, "cannot be equal");

// TODO : this rule has a very generic name and a very specific implementation,
// either change the name or make it accept various types of requirements. -jw : 06-06-2012
$.validator.addMethod("extComboRequired", function(val, el) {
    if (val !== "") {
        $(el).closest(".category").removeClass("field_with_errors");
        return true;
    } else {
        $(el).closest(".category").addClass("field_with_errors");
        return false;
    }
}, "A category selection is required.");

jQuery.validator.addMethod("number", function(a, b) {
    return this.optional(b) || /^-?\$?\.?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/.test(a);
}, "Please enter a valid number");

jQuery.validator.addMethod("phoneUS", function(phone_number, element) {
    phone_number = phone_number.replace(/\s+/g, "");
    return this.optional(element) || phone_number.length > 9 && phone_number.match(/^([\(]{1}[0-9]{3}[\)]{1}[\.| |\-]{0,1}|^[0-9]{3}[\.|\-| ]?)?[0-9]{3}(\.|\-| )?[0-9]{4}$/);
}, "Please specify a valid phone number");

$.validator.setDefaults({
    highlight: function(element, errorClass) {
        $(element).closest('.field').addErrors();
    },
    unhighlight: function(element, errorClass) {
        $(element).closest('.field').removeErrors();
    },
    ignore: ".ignore",
    errorPlacement: function() {}, // don't put error labels anywhere in the form.
    showErrors: function(errorMap, errorList) {
        var $form = $('#' + this.currentForm.id);
        if (errorList && errorList.length) {
            displayErrorContainerForForm($form);
            var errors = [],
                messages = [];
            // prevent dups.
            $.each(errorMap, function(i, n) {
                if (errors.indexOf(n) > -1) return true; // continue..
                errors.push(n);
                messages.push('<li>' + n + '</li>');
            });
            if (messages.length) {
                $form.find('.errors ul').html(messages.join(''));
            }
        }
        this.defaultShowErrors();
    },
    onkeyup: false,
    focusInvalid: false
});


$.extend({
    TODAY: Alkami.Utils.DateHelper.today(),
    clearErrors: function() {
        $('.field_with_errors').removeErrors();
    },
    isJSON: function(json) {
        json = json.replace(/\\["\\\/bfnrtu]/g, '@');
        json = json.replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']');
        json = json.replace(/(?:^|:|,)(?:\s*\[)+/g, '');
        return (/^[\],:{}\s]*$/.test(json));
    },
    dateRangePresets: {
        future: [
            { text: Alkami.Localization.SiteText["jQuery.DateRangePicker.Options.Today"], dateStart: 'today', dateEnd: 'today' },
            { text: Alkami.Localization.SiteText["jQuery.DateRangePicker.Options.NextThirty"], dateStart: 'today', dateEnd: 'today+30days' },
            { text: Alkami.Localization.SiteText["jQuery.DateRangePicker.Options.NextSixty"], dateStart: 'today', dateEnd: 'today+60days' },
            { text: Alkami.Localization.SiteText["jQuery.DateRangePicker.Options.NextNinety"], dateStart: 'today', dateEnd: 'today+90days' }
        ],
        past: [
            { text: Alkami.Localization.SiteText["jQuery.DateRangePicker.Options.Today"], dateStart: 'today', dateEnd: 'today' },
            { text: Alkami.Localization.SiteText["jQuery.DateRangePicker.Options.LastThirty"], dateStart: 'today-30days', dateEnd: 'today' },
            { text: Alkami.Localization.SiteText["jQuery.DateRangePicker.Options.LastSixty"], dateStart: 'today-60days', dateEnd: 'today' },
            { text: Alkami.Localization.SiteText["jQuery.DateRangePicker.Options.LastNinety"], dateStart: 'today-90days', dateEnd: 'today' },
            {
                text: Alkami.Localization.SiteText["jQuery.DateRangePicker.Options.YearToDate"],
                dateStart: function() {
                    var x = Alkami.Utils.DateHelper.today();
                    x.setMonth(0);
                    x.setDate(1);
                    return x;
                },
                dateEnd: 'today'
            }
        ]
    }
});

(function($) {
    $.expr.pseudos.Contains = function(a, i, m) {
        return (a.textContent || a.innerText || "").toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
    };

    $.fn.extend({
        disableSubmit: function(disabledText) {
            return this.each(function() {
                var submit = $(':submit', this);
                if (!disabledText)
                    disabledText = submit.val();

                submit.data('original-value', submit.val());
                submit.attr('disabled', 'disabled').val(disabledText).css({ opacity: .5 });
            });
        },
        enableSubmit: function() {
            return this.each(function() {
                var submit = $(':submit', this);
                submit.removeAttr('disabled', 'disabled').css({ opacity: 1 });
                if (submit.data('original-value'))
                    submit.val(submit.data('original-value'));
            });
        },
        showFlash: function(config) {
            return this.each(function() {
                Alkami.FlashBanner.flashBanner($(this)[0], config);
            });
        },
        swapStylesheet: function(url) {
            var newcss;
            newcss = $(this).attr('href', url);
            return newcss;
        },
        ajaxFileUpload: function(opts) {
            var defaults = {
                url: "/Image/PreviewImage",
                success: function() { return; } // NOOP function
            };

            opts = Object.assign(defaults, opts);

            return this.each(function() {
                var $field = $(this),
                    $form = $field.closest('form');

                $.ajax({
                    type: 'POST',
                    url: opts.url,
                    data: new FormData($form[0]),
                    contentType: false,
                    processData: false,
                    success: function(data, status, xhr) { return opts.success(xhr); }
                });
            });
        },
        multiFileUpload: function(opts) {
            var rx = /(ade|adp|app|bas|bat|chm|cmd|cpl|crt|csh|exe|fxp|hlp|hta|inf|ins|isp|js|jse|ksh|Lnk|mda|mdb|mde|mdt|mdt|mdw|mdz|msc|msi|msp|mst|ops|pcd|pif|prf|prg|pst|reg|scf|scr|sct|shb|shs|url|vb|vbe|vbs|wsc|wsf|wsh)/gi;
            var fileCount = 0;

            return this.each(function() {
                var $this = $(this);
                $this.wrap('<div id="' + this.id + '_wrap" class="multi-file-upload"></div>');
                var list = $('<div id="' + this.id + '_list" class="multi-file-list"></div>');
                var wrapper = $('#' + this.id + '_wrap');
                wrapper.prepend(list);

                $this.filestyle(opts.filestyleOpts);

                var files = [];

                $this.data('wrapper', wrapper);

                $this.change(function() {
                    var $this = $(this);
                    console.log('file has been selected');
                    var fileName = this.value.replace("C:\\fakepath\\", ""),
                        ext = fileName.substr(fileName.lastIndexOf('.'));

                    // check extension
                    if (rx.test(ext)) {
                        // file type not allowed
                        Alkami.FlashBanner.showError('Files of type ' + ext + ' are not allowed. Please try again.');
                        return false;
                    }

                    if (files.length && (files.indexOf(fileName) > -1)) {
                        Alkami.FlashBanner.showError('The selected file has already been attached. Please select a different file.');
                        return false;
                    }

                    var fail = opts.onUploadFail || function() {};

                    // do upload if OK
                    $this.ajaxFileUpload({
                        url: opts.uploadUrl,
                        success: function(response, options) {
                            var text = response.responseText;

                            // why use a string and test it with a regex if something failed? #dailywtf
                            // leaving this condition for reverse compat, the server should return an object with a "success" prop
                            // - JR 09.12.12

                            // text will be blank in the case of 500 error, otherwise if it contains the term "Error"
                            if (!text.length || /Server Error/.test(text)) {
                                fail(text);
                                return false;
                            }

                            var res = JSON.parse(text);
                            if (res.upgrade) { // modal result here, it would have skipped the obove error block
                                if (!res.success) { // did it fail
                                    fail(res.flash, true);
                                    return false;
                                } else {
                                    res = res.result;
                                }
                            }

                            res.fileSize = Math.round(res.fileSize / 1000) + 'KB';
                            res.contentType = res.contentType.substr(res.contentType.lastIndexOf("/") + 1);

                            var $item = $('<div class="file">' +
                                '<span class="img type-' + res.contentType + '"></span>' +
                                '<span class="filename">' + res.fileName + '</span>' +
                                '<span class="filesize">' + res.fileSize + '</span>' +
                                '<a class="remove" href="#">Delete</a>' +
                                '</div>');

                            $item.appendTo(list).find('.remove').on('click', function(e) {
                                e.preventDefault();
                                // remove from list, remove from 'files', remove last input field.
                                $item.remove();
                                var idx = files.indexOf(res.fileName);
                                if (idx != -1) { files.splice(idx, 1); }
                                var toRemove = wrapper.find('input[type=file]').last().closest('div');
                                toRemove.prev('input').remove();
                                toRemove.remove();
                                wrapper.find('input[type=file]').last().closest('div').show();
                                fileCount--;
                            });

                            var $clone = $this.clone(true);
                            $this.closest('div').hide();

                            wrapper.append($clone);

                            $clone.filestyle(opts.filestyleOpts);

                            if (++fileCount == opts.max) {
                                $clone.attr('disabled', 'disabled').css({ cursor: 'default' }).closest('div').addClass('disabled').css({ opacity: 0.5 });
                            }

                            files.push(res.fileName);


                        }
                    });
                });
            });
        },
        bindDateRangePicker: function(opts, future) {
            var $field = $(this);

            // Check to see if this control has already been bound.
            if (typeof $field.data("dateRangePicker") !== 'undefined')
                return;

            $field.data("dateRangePicker", true);

            // Just remove existing date range pickers, as they cannot be destroyed properly.
            $('.ui-daterangepicker').remove();

            var presets = $.dateRangePresets[future ? 'future' : 'past'];

            var settings = {
                datepickerOptions: {
                    showOtherMonths: true,
                    selectOtherMonths: true
                },
                doneButtonText: '<span class="button">' + Alkami.Localization.SiteText["jQuery.DatePicker.DoneButton"] + '</span>',
                presetRanges: presets
            };

            if (opts.startField && opts.endField) {
                settings.onChange = function() {
                    opts.startField.val($.datepicker.formatDate('yy-mm-dd', $('.ui-daterangepicker').find('.range-start').datepicker('getDate')));
                    opts.endField.val($.datepicker.formatDate('yy-mm-dd', $('.ui-daterangepicker').find('.range-end').datepicker('getDate')));
                    opts.startField.trigger('change');
                    opts.endField.trigger('change');
                };

                // when the user manually enters a date, make sure the attached hidden fields get updated as well.
                $field.off('blur.dateRangePicker').on('blur.dateRangePicker', function(e) {
                    var dateRange = $(this).val(),
                        matches = dateRange.split('-'),
                        startDate,
                        endDate;

                    try {
                        startDate = $.datepicker.parseDate('mm/dd/yy', $.trim(matches[0]));

                        if (matches.length === 1) {
                            // if only one date in the field (i.e. not a range), set it to both start and end
                            endDate = $.datepicker.parseDate('mm/dd/yy', $.trim(matches[0]));
                        } else {
                            // otherwise set the end to the one in the range
                            endDate = $.datepicker.parseDate('mm/dd/yy', $.trim(matches[1]));
                        }
                        if (startDate && endDate && !(endDate >= startDate)) {
                            //                            invalidate();
                            return;
                        }
                        opts.startField.val($.datepicker.formatDate('yy-mm-dd', startDate));
                        opts.endField.val($.datepicker.formatDate('yy-mm-dd', endDate));
                    } catch (e) {
                        //                        invalidate();
                    }
                });
            }

            $.extend(settings, opts);

            if (!future) {
                var dateArray = new String('2006-01-01').split('-');
                var minDateObject = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
                // Allows the user to provide a custom minDate, without it being overwritten by the minDateObject.
                settings.datepickerOptions.minDate = settings.datepickerOptions.minDate || minDateObject;
                // Allows the user to provide a custom maxDate, without it being overwritten by the $.TODAY.
                settings.datepickerOptions.maxDate = settings.datepickerOptions.maxDate || $.TODAY;
            }
            $field.daterangepicker(settings);
        },
        calendars: function(opts) {
            // Set default css class to look for list items in.
            var className = "list-item";

            if (opts && opts.cssClass) {
                className = opts.cssClass;
            }

            $(document).on('click', function(event) {
                // if they click on any exceptions, allow it to be selected.
                if ($(event.target).hasClass('list-item') || $(event.target).hasClass('event') || $(event.target).closest('.list-item').length || $(event.target).closest('.event').length)
                    return;

                // otherwise they clicked somewhere else on the page, remove the selection.
                $('.day.event.selected-day').removeClass('selected-day');
                $('.' + className + '.selected').removeClass('selected');
            });

            // When a user clicks a day, select it and the item in the list
            $(document).on('click', '.day.event', function(e) {
                $('.list .' + className + '.selected').removeClass('selected');
                $('.day.event.selected-day').removeClass('selected-day');

                $(this).addClass('selected-day');
                $.each($(this).attr('class').split(" "), function(n, i) {
                    $('.' + className + '' + '#' + i).addClass('selected');
                });

                return false;
            });

            // When a user clicks an item in the list, select it and select the days in the calendar
            $(document).on('click', '.list .' + className, function(e) {
                $('.list .' + className + '.selected').removeClass('selected');
                $('.day.event.selected-day').removeClass('selected-day');

                $(this).addClass('selected').removeAttr('style');
                $('#calendars .day.' + $(this).attr('id')).addClass('selected-day');

                return false;
            });
        },
        addErrors: function() {
            this.addClass('field_with_errors');
        },
        removeErrors: function() {
            this.removeClass('field_with_errors');
        },
        hasErrors: function() {
            return this.hasClass('field_with_errors');
        },
        serializeHash: function(opts) {
            var p = {},
                opts = opts || {};
            var a = this.serializeArray(opts);
            $.each(a, function(i, n) {
                p[n.name] = n.value;
            });
            return p;
        },

        instructify: function() {
            return this.each(function() {
                var promptComponent;
                var $c = $(this);

                $c.on('click', function(e) {
                    e.preventDefault();

                    var $contentElement = $('<div></div>').html('<div class="loading-indicator">Loading...</div>');
                    $.get($c.attr('href'), function(data) {

                        $contentElement.html(data);
                        if (!$('#modal_sidenav').length) {
                            return this;
                        }

                        var $parent = $('.tab-panel-container');
                        $parent.find('.panel').hide();

                        $('#modal_sidenav .list-item').on('click', function() {
                            if ($(this).hasClass('current')) {
                                return false;
                            } else {
                                var $currLink = $(this);
                                var $active = $parent.find('.panel.active');
                                $('#modal_sidenav .list-item.current').removeClass('current');
                                $currLink.addClass('current');

                                if ($active.length) {
                                    $active.hide(0).removeClass('active');
                                }
                                $('.panel' + $currLink.attr('href')).show().addClass('active');

                                return false;
                            }
                        });

                        $('#modal_sidenav ul li:first-child a').trigger('click');
                    });

                    promptComponent = Alkami.Helpers.createCloseDialog($contentElement[0], { title: $c.text() || 'Help', cls: 'instructions', destroyOnClose: true });
                    promptComponent.open = true;
                });
            });
        },
        toolTip: function(options) {
            // Default options.
            var defaults = {
                useTitle: false,
                tipCss: null,
                autoCleanup: true,
                selector: null
            };

            // Settings object we can extend if necessary.
            var settings = $.extend(defaults, options);
            if (!settings.selector && this.length === 0) { return; }

            // Set the tooltip text from the title attribute.
            function setTooltipText($thisEl) {
                var tooltipText;

                if (settings.useTitle) {
                    // If the title attibute is empty (assuming we have grabbed it already).
                    if ($thisEl.attr('title') !== '') {
                        tooltipText = $thisEl.attr('title');

                        $thisEl.data('title', tooltipText);
                        $thisEl.attr('title', '');
                    } else {
                        tooltipText = $thisEl.data('title');
                    }
                } else {
                    var $tipContainer = $thisEl.find('.tip');

                    if (!$tipContainer.length)
                        $tipContainer = $('#' + $thisEl.attr('rel'));

                    tooltipText = $tipContainer.html();
                }

                return tooltipText;
            }

            function removeTooltipHtml(wrapper) {
                wrapper.fadeOut(300, function() {
                    wrapper.remove();
                });
            }

            function mouseenterHandler(event) {
                var $this = $(this);

                // Various tooltip settings. Always prioritize the data attributes over the setting object.
                var tipPositionAt = $this.data('tippositionat');
                var autoCleanup = typeof $this.data('auto-cleanup') !== 'undefined' ? $this.data('auto-cleanup') : settings.autoCleanup;
                var keepState = $this.data('keep-state');

                // Tooltip markup variables.
                var wrapper = null;
                var container = null;

                // Timeout instance ID's for cleanup purposes.
                var autoRemovalTimeout = null;
                var creationDebounce = null;

                // On a mouseenter event kick off the function to create the tooltip.
                // This is a setTimeout function so that you can't hover over multiple tooltips in short succession.
                creationDebounce = setTimeout(function() {
                    var tooltip = setTooltipText($this);

                    if ($this.data('tooltipElement')) {
                        if (tooltip != '')
                            $this.data('tooltipElement').find('.tooltip-content').html(tooltip);

                        $this.data('tooltipElement').hide().fadeIn(300);
                    } else {
                        wrapper = $('<div class="tooltip-wrapper" />');
                        container = $('<div class="tooltip-container" />');
                        var content = $('<div class="tooltip-content" />');

                        if ($this.data('tipclass'))
                            content.addClass($this.data('tipclass'));

                        if (settings.tipCss) {
                            content.css(settings.tipCss);
                        }

                        wrapper.append(container.append(content));
                        $('body').append(wrapper);

                        content.append(tooltip);
                        wrapper.hide().fadeIn(300);

                        wrapper.position({
                            my: 'center top',
                            at: tipPositionAt || 'center bottom',
                            collision: "none none",
                            offset: '0 0',
                            of: $this
                        });

                        $this.data('tooltipElement', wrapper);
                    }
                }, 50);

                // Also create the mouseleave event on the same element we just entered.
                $this.on('mouseleave', function() {
                    wrapper = $this.data('tooltipElement');
                    related = event.relatedTarget || event.toElement;

                    // If we are here make sure we don't need to clear a creation start event.
                    if (typeof creationDebounce === 'number')
                        window.clearTimeout(creationDebounce);

                    if (wrapper) {
                        if (keepState === false) {
                            $this.removeData('tooltipElement');
                            removeTooltipHtml(wrapper);

                        } else if (related && related != wrapper[0]) {
                            wrapper.fadeOut(300);
                        }

                        // Make sure we clear out the timeout if the mouseleave event is fired.
                        if (typeof autoRemovalTimeout === 'number')
                            window.clearTimeout(autoRemovalTimeout);

                        // Now that we have cleaned up, dispose of the event handler.
                        $this.off('mouseleave');
                    }
                });

                // If this is active, we will automatically remove the tooltip after 4 seconds.
                if (autoCleanup) {
                    // Set a variable to the returned timeout ID so we can clear it later if necessary.
                    autoRemovalTimeout = setTimeout(function() {
                        wrapper = $this.data('tooltipElement');
                        related = event.relatedTarget || event.toElement;

                        if (wrapper) {
                            if (keepState === false) {
                                $this.removeData('tooltipElement');
                                removeTooltipHtml(wrapper);

                            } else if (related && related != wrapper[0]) {
                                wrapper.fadeOut(300);
                            }
                        }
                    }, 4000);
                }
            }

            if (settings.selector) {
                $(document).on('mouseenter', settings.selector, mouseenterHandler);
            } else {
                this.on('mouseenter', mouseenterHandler);
            }

            console.warn('$.fn.toolTip is deprecated. Please use Iris Tooltips instead.');
            return this;
        },
        contentSlider: function(options) {
            var defaults = {
                slideTrigger: '.slide-trigger',
                expandBtn: '.expand',
                expandBtnTxt: 'Show Search',
                collapseBtn: '.collapse',
                collapseBtnTxt: 'Hide Search',
                slideContent: '.slide-content',
                collapsedByDefault: true
            };
            var settings = $.extend(defaults, options);

            if (this.length > 0) {
                console.warn('$.fn.contentSlider is deprecated. Please use Iris Collapsable instead.')
            }
            return this.each(function() {

                if (settings.collapsedByDefault === true) {
                    $(settings.slideContent).hide();
                    $(settings.slideTrigger).removeClass('collapse').addClass('expand').find('span').text(settings.expandBtnTxt);
                } else {
                    $(settings.slideTrigger).removeClass('expand').addClass('collapse').find('span').text(settings.collapseBtnTxt);
                }

                $(settings.slideTrigger).on('click', function() {
                    if ($(settings.slideTrigger).hasClass('expand')) {
                        $(settings.slideContent).slideDown(function() { $(settings.slideTrigger).removeClass('expand').addClass('collapse').find('span').text(settings.collapseBtnTxt) });
                    } else {
                        $(settings.slideContent).slideUp(function() { $(settings.slideTrigger).removeClass('collapse').addClass('expand').find('span').text(settings.expandBtnTxt) });
                    }
                    return false;
                });
            });
        },
        ajaxFilters: function(options) {
            return this.each(function() {
                var $form = $(this);

                // do anything you need before the rest of the form is initialized.
                if (options.prepare) {
                    options.prepare.call();
                }

                $form.data('selects', []);

                // DEV-3839 - stopTransform is a custom option that will prevent ExtJS from transforming the select fields in a given form.
                if (!options.stopTransform) {
                    $form.find('select').each(function() {
                        var value = getUrlParam(this.name);
                        var t = transformSelect(this.id, { value: value });
                        $form.data('selects').push(t);
                    });
                }

                $form.submit(function(e) {
                    e.preventDefault(); // don't submit the form by traditional means.

                    if (options.submit) {
                        options.submit.call(e, $form);
                    }
                    // update dom with simple 'get' request with form data, will do a simple replace on the element with id passed to options.update
                    else if (options.update) {
                        $.get($form.attr('action'), $form.serialize(), function(data) {
                            $('#' + options.update).fadeOut('normal', function() {
                                $('#' + options.update).replaceWith(data);
                            });
                        }, 'html');
                    }
                });
                $form.find(':reset').on('click', function(e) {
                    $.each($form.data('selects'), function(i, n) {
                        n.reset();
                    });
                    if (options.reset) {
                        options.reset.call();
                    } else if (options.update) {
                        $.get($form.attr('action'), null, function(data) {
                            $('#' + options.update).fadeOut('normal', function() {
                                $('#' + options.update).replaceWith(data);
                            });
                        }, 'html');
                    }
                    //Add preventDefault to prevent browser clear the default value of form fields
                    e.preventDefault();
                });
            });
        }
    });

    $.fn.prompt = (function() {
        var prompt = function(el, opts) {
            this.el = $(el);
            this.opts = $.extend({}, this.defaults, opts);
        };

        prompt.prototype = {
            defaults: {
                tpl: '<div><span class="message"></span><input type="button" class="yes button" value="' +
                    Alkami.Localization.SiteText['Modal.Confirm.Button.Delete'] +
                    '" /><input type="button" value="' +
                    Alkami.Localization.SiteText['Modal.Confirm.Button.Cancel'] +
                    '" class="button secondary" /></div>',
                cb: function(confirmed, e) {}
            },
            init: function() {
                this.create();
                this.bind();
                this.position();
            },
            bind: function() {
                var self = this;
                this.markup.click(false) /*<- can someone tell me what this does?*/ .find('input[type="button"]').on('click', function(e) {
                    if (self.opts.cb) {
                        var r = self.opts.cb.call(self, $(e.target).hasClass('yes'), e);
                        if (r === true || r === undefined) self.close(e);
                    } else self.close(e);
                });
                $(document).on('click.prompt', $.proxy(self.close, self));
            },
            close: function(e) {
                if (this.opts.close) {
                    this.opts.close.apply(this, arguments);
                }
                if (!e.isPropagationStopped()) {
                    $(document).unbind('click.prompt', this.close);
                    this.markup.remove();
                }
            },
            create: function() {
                this.markup = $('<div class="prompt x-window-plain x-plain" />')
                    .append(this.opts.tpl)
                    .find('span.message')
                    .html(this.opts.text)
                    .end()
                    .css('visibility', 'hidden')
                    .prependTo('body');
            },
            position: function() {
                var pos = this.el.offset(),
                    h = this.el.height(),
                    w = this.markup.width() || 200;
                this.markup.css({ top: pos.top + h + 5, left: pos.left - w });
            },
            open: function() {
                this.markup.hide().css('visibility', 'visible');
                this.markup.fadeIn(100, function() {
                    $(this).find('input[type="button"]:first').focus();
                });
            }
        };

        return function(opts) {
            console.warn('$.fn.prompt is deprecated. Please use Alkami.Helpers.createConfirmationDialog instead.')
            opts = opts || {};
            return this.on('click', opts.selector, function(e) {
                var p = new prompt(e.target, opts);
                p.init();
                p.open();
                return false;
            });
        };
    })();
    /// Desc: jquery extension to make a link do a POST request instead of GET
    /// Usage:  $('a.post-link).postLink()'
    $.fn.postLink = (function() {
        var PostLink = function(el, opts) {
            $.extend(this, opts);
            this.el = $(el);
            this.init();
        };

        PostLink.prototype = {
            init: function() {
                var url = this.el.attr('href');
                this.parts = url.split('?');
                this.url = this.parts[0];
                this.params = this.parts.length > 1 ? plugin.parseQuery(this.parts[1]) : {};

                // bind the click
                if (!this.el.on)
                    this.el.on('click', $.proxy(this.click, this));
            },
            // generage a post action for this link
            click: function(e) {
                e.preventDefault();
                e.stopPropagation();

                var form = $('<form />')
                    .attr('action', this.url)
                    .attr('method', 'POST');

                // if there are query string params
                for (var k in this.params) {
                    $('<input type="hidden" />').attr('name', k)
                        .attr('value', this.params[k]).appendTo(form);
                }
                // go! no cleanup required this redirects the page
                form.appendTo(document.body).submit();
                return false;
            }
        };

        var plugin = function(opts) {
            console.warn('$.fn.postLink is deprecated. Please use Alkami.Helpers.Form.postLink in a click handler.')
            if (opts.on) {
                var selector = opts.selector || 'a.post-link';
                $(document).on('click', selector, function(e) {
                    var el = $(this);
                    var instance = el.data('postLink');
                    if (!instance) {
                        instance = new PostLink(this, opts);
                    }
                    instance.on('click', e);
                    return false;
                });
                return this;
            } else {
                return this.each(function() {
                    if (!$(this).data('postLink'))
                        $(this).data('postLink', new PostLink(this, opts));
                });
            }
        };

        // static function for sharing out the parse querystring
        // decode URL into object hash
        plugin.parseQuery = function(q) {
            console.warn('$.fn.postLink.parseQuery is deprecated. Please use URLSearchParms instead.');
            const params = new URLSearchParams(q);
            const result = {};

            params.forEach(function(value, key) {
                result[key] = value;
            });
        };

        return plugin;
    })();


    // https://gist.github.com/1572512
    // supports checkboxes with serialize jquery function
    $.fn.serialize = function(options) {
        return $.param(this.serializeArray(options));
    };

    $.fn.serializeArray = function(options) {
        var o = $.extend({
            checkboxesAsBools: false
        }, options || {});

        var rselectTextarea = /select|textarea/i;
        var rinput = /text|hidden|password|search/i;

        return this.map(function() {
                return this.elements ? $.makeArray(this.elements) : this;
            })
            .filter(function() {
                return this.name && !this.disabled &&
                    (this.checked ||
                        (o.checkboxesAsBools && this.type === 'checkbox') ||
                        rselectTextarea.test(this.nodeName) ||
                        rinput.test(this.type));
            }).map(function(i, elem) {
                var val = $(this).val();
                return val == null ?
                    null :
                    $.isArray(val) ?
                    $.map(val, function(val, i) {
                        return { name: elem.name, value: val };
                    }) : {
                        name: elem.name,
                        value: (o.checkboxesAsBools && this.type === 'checkbox') ? //moar ternaries!
                            (this.checked ? 'true' : 'false') : val
                    };
            }).get();
    };

})(jQuery);





